import { Icon } from '@payfit/growth-platform-brand-system-v2/components/Picto/Icon';
import {
  fontBodyMini,
  fontCaption,
  fontCaptionMedium,
} from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import { SiteLocale } from 'apps/website/types/dato';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import React from 'react';
import { numberEmployeeStyle } from '../scripts/commonStyles';
import { formatPrice } from '../../../../utils/formatPrice';
import { translation } from '../scripts/translation';

type CalculationProps = {
  frequencyLabel: string;
  priceLabel: string;
  baseLabel: string;
  totalLabel: string;
  price: number;
  numberEmployee: number;
  base: number;
  total: number;
  locale: SiteLocale;
};

const Calculation = ({
  frequencyLabel,
  priceLabel,
  baseLabel,
  totalLabel,
  price,
  numberEmployee,
  base,
  locale,
  total,
}: CalculationProps) => {
  return (
    <div
      className={classNames(
        'PriceBreakdown_Calculation',
        'flex flex-col gap-x-16 gap-y-[2px]',
      )}
    >
      <div className={classNames(fontCaptionMedium)}>{frequencyLabel}</div>
      <div className={classNames('flex justify-between text-[#55687D]')}>
        <div className={classNames(fontCaption)}>{priceLabel}</div>
        <div className={classNames(fontCaption)}>
          {price} x{' '}
          <span className={classNames(numberEmployeeStyle)}>
            {numberEmployee}
          </span>{' '}
          = {formatPrice(price * numberEmployee, locale)}
        </div>
      </div>
      <div className={classNames('flex justify-between text-[#55687D]')}>
        <div className={classNames(fontCaption)}>{baseLabel}</div>
        <div className={classNames(fontCaption)}>
          {formatPrice(base, locale)}
        </div>
      </div>
      <div className={classNames('flex justify-between', fontCaptionMedium)}>
        <div className={classNames('flex items-center gap-[8px]')}>
          <Icon
            className={classNames('h-[20px] w-[20px] text-[#364A61]')}
            name="info_square"
          />{' '}
          {totalLabel}
        </div>
        <div className={classNames(fontBodyMini)}>
          {formatPrice(total, locale)}{' '}
          {translation[locale]?.['price.withoutTax']}
        </div>
      </div>
    </div>
  );
};

export default Calculation;
